export const resetModalScroll = (): void => {
  document
    .querySelectorAll<HTMLElement>('.BaseModal-Overlay')
    .forEach((overlay) => {
      overlay.scrollTop = 0
    })

  if (document.scrollingElement) {
    document.scrollingElement.scrollTop = 0
  }
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}
